import { DeliUser } from '@lib/common';
import { useEffect, useState } from 'react';
import { Subject } from 'rxjs';

let user: DeliUser;
export const events$ = new Subject<DeliUser>();

/**
 * Check if the user is logged in.
 */
export function isLoggedIn(): boolean {
  return !!user;
}

/**
 * Get the user
 */
export function getUser(): DeliUser {
  return user;
}

/**
 * Set the user.
 */
export function setUser(userToSet: DeliUser) {
  user = userToSet;
  events$.next(user);
}

export function clearUser() {
  user = null;
  events$.next(user);
}

/**
 * Get the current user. can be null.
 */
export function useUser() {
  const [hookUser, setHookUser] = useState<DeliUser | null>(getUser());
  const [isLoggedInHook, setIsLoggedIn] = useState<boolean>(isLoggedIn());
  useEffect(() => {
    const sub = events$.subscribe(u => {
      setHookUser(u);
      setIsLoggedIn(isLoggedIn());
    });
    return () => sub.unsubscribe();
  }, []);

  return { user: hookUser, isLoggedIn: isLoggedInHook } as const;
}
